var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"AdminUser"},[_c('AdminUsersHeader',{on:{"onChangeTab":_vm.onChangeTab}}),_c('transition',{attrs:{"name":"fade"}},[(!_vm.isLoading)?_c('AdminUsersTable',{ref:"userTable"}):_vm._e()],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }